import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function HeroSection() {
  return <section className="min-h-screen bg-[#0A0A0A] px-5 py-16 md:py-24" data-id="element-84">
      <motion.div className="max-w-3xl mx-auto" variants={containerVariants} initial="hidden" animate="visible" data-id="element-85">
        <motion.p variants={itemVariants} className="text-[#E8732A] text-sm md:text-base font-medium tracking-wide uppercase mb-6" data-id="element-86">
          Para afiliados en español
        </motion.p>

        <motion.h1 variants={itemVariants} className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.1] mb-8" data-id="element-87">
          Vistas <span className="text-[#E8732A]" data-id="element-88">≠</span> Ventas
        </motion.h1>

        <motion.p variants={itemVariants} className="text-xl md:text-2xl text-[#A0A0A0] leading-relaxed mb-10" data-id="element-89">
          Arregla tu "puente" en 7 días
        </motion.p>

        <motion.div variants={itemVariants} className="bg-[#141414] border-l-4 border-[#E8732A] p-6 md:p-8 mb-12" data-id="element-90">
          <p className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed space-y-4" data-id="element-91">
            <span className="block mb-4" data-id="element-92">Te voy a describir una escena.</span>
            <span className="block mb-4" data-id="element-93">Subes un video. Le va bien.</span>
            <span className="block mb-4 text-white" data-id="element-94">
              Comentarios: "info", "¿dónde lo consigo?", "me interesa".
            </span>
            <span className="block mb-4" data-id="element-95">Tú respondes: "link en la bio".</span>
            <span className="block mb-4" data-id="element-96">
              Y después… <span className="text-white font-semibold" data-id="element-97">nada.</span>
            </span>
            <span className="block text-white font-semibold" data-id="element-98">Silencio.</span>
          </p>
        </motion.div>

        <motion.p variants={itemVariants} className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed mb-12" data-id="element-99">
          No es que tu contenido sea malo. Es peor: tu contenido está
          funcionando… pero está llevando a la gente a una{' '}
          <span className="text-[#E8732A] font-semibold" data-id="element-100">puerta cerrada</span>.
        </motion.p>

        <motion.div variants={itemVariants} className="flex justify-center mb-12" data-id="element-101">
          <img src="https://cdn.magicpatterns.com/uploads/9XcUtunNnd6FtfJdTRpx3e/jJXsO4bbQl5RMCV1UNoDj.png" alt="Vistas ≠ Ventas - Toolkit de Conversión para Afiliados en 7 Días" className="w-full max-w-md rounded-lg shadow-2xl shadow-black/50" data-id="element-102" />
        </motion.div>

        <motion.div variants={itemVariants} className="text-center" data-id="element-103">
          <a href="#precio" className="inline-block bg-[#E8732A] hover:bg-[#d4662a] text-white font-bold text-lg md:text-xl px-8 py-4 rounded-lg transition-colors duration-200" data-id="element-104">
            Quiero arreglar mi conversión →
          </a>
        </motion.div>
      </motion.div>
    </section>;
}